import store from 'app/store';

export default (Resource, entity, ...rest) => store.dispatch(Resource.create(entity, ...rest));
